import React, { useEffect } from 'react'
import util from 'meinian-package/src/utils/util'
import qs from 'qs'
import { DetailContent } from '../imageDetail'

export default () => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })

  useEffect(() => {
    if (query.trackSourceType) {
      util.track('mn-style-detail-page', {
        module1: query.trackSourceType
      })
    }
  }, [])

  return <DetailContent
    blogId={query.imageGroupEntityId}
    inspirationId={query.inspirationId}
    collectId={query.collectId}
  />
}
